import { CommonService } from 'app/services/common.service';
import { DataService } from './../../services/data.service';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { NotificationService } from './../../services/notification.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { DraggableModalService } from '../shared/draggable-modal/draggable-modal.service';
import { Subscription } from 'rxjs';
import { CommonStudentService } from '../../services/common-student.service';
import { DraggableModal } from '../shared/draggable-modal/draggable-modal.class';
import { LoginInfoProvider } from '../../ev-dal/login-info.provider';

@Component({
  selector: 'app-parent-child-plan',
  templateUrl: './parent-child-plan.component.html',
  styleUrls: ['./parent-child-plan.component.scss']
})
export class ParentChildPlanComponent implements OnInit, OnDestroy {
  brickColors = this.dataService.getEntity('Brick Temperature').item;

  heatMapData;
  categoryList;
  tempList;
  parentChildData: any;
  parentHeatMapLoader = false;
  baseBrickModalId = 'heat-map-modal';
  brickDetailData: any[];
  brickDetailTitle: string;
  isMobileVersion: boolean;
  subs: Subscription[] = [];
  programsList = [];
  programSelected = 0;
  brickAllData = [];
  brickReadStatus = [];
  selectedBrickTitle: string;
  personalityAssessmentJson: any;
  learningAssessmentJson: any;
  careereAssessmentJson: any;


  constructor(
    private notificationService: NotificationService,
    public _commonRequestResponseService: CommonRequestResponseService,
    public commonDataSharedService: CommonDataSharedService,
    private dataService: DataService,
    private _commonService: CommonService,
    private draggableModalService: DraggableModalService,
    private _commonStudentService: CommonStudentService,
    private _loginInfoProvider: LoginInfoProvider
  ) { }

  ngOnInit() {
    this.isMobileVersion = this._commonService.checkDeviceIsMobile();
    this.parentChildData = JSON.parse(
      localStorage.getItem('parentChildLocalData')
    );
    if (this.parentChildData) {
      this.getHeatMapData(this.programSelected);
      this.getProgramData();
    }
    const openedModals = this.draggableModalService
      .getModals()
      .filter(modal => modal.instance)
      .map(modal => modal.instance);
    openedModals
      .filter(
        modal => modal.modalRef && modal.id.indexOf('heat-map-modal') > -1
      )
      .forEach((modal: DraggableModal) => {
        modal.modalRef.content._saveBrickContent.subscribe(() => {
          this.getHeatMapData(this.programSelected);
          this.getProgramData();
        });
      });
    this.subs.push(
      this.commonDataSharedService.parentHomeData.subscribe((data: any) => {
        this.parentChildData = data;
        this.getHeatMapData(this.programSelected);
        this.getProgramData();
      }),
      this.draggableModalService.modalOpened.subscribe(
        (modal: DraggableModal) => {
          if (modal.id.indexOf('heat-map-modal') > -1) {
            modal.modalRef.content._saveBrickContent.subscribe(() => {
              this.getHeatMapData(this.programSelected);
              this.getProgramData();
            });
          }
        }
      )
    );
  }

  getCounter() {
    if (this.categoryList && this.categoryList.length) {
      for (let i = 0; i < this.categoryList.length; i++) {
        this.categoryList[i]['counter'] = 0;
        for (let j = 0; j < this.heatMapData.length; j++) {
          if (
            this.categoryList[i].value === this.heatMapData[j].categoryClassID
          ) {
            this.categoryList[i]['counter']++;
          }
        }
      }
    }
  }

  getProgramData() {
    const getServicesInputJson = {
      studentId: this.parentChildData.studentUserId,
      partnerId: this._loginInfoProvider.partnerId
    };
    this._commonRequestResponseService
      .postWithHeader(
        'shared/GetStudentsParentsForAccount',
        getServicesInputJson
      )
      .subscribe(
        (servicesJSON: any) => {
          servicesJSON.items.forEach(element => {
            if (element.id === this.parentChildData.studentUserId) {
              this.programsList = element.assignHeatMaps;
            }
          });
        },
        () => {
          this.notificationService.show('info', 'No values data exists for this reference type');
        });
  }

  getHeatMapData(event) {
    this.heatMapData = [];
    this.programsList.forEach((data, index) => {
      if (event.index === index) {
        this.programSelected = data.HeatMapID;
        this.contentProgramChange();
      }
    });
    if (this.programSelected) {
      this._commonStudentService.getHeatMapData(this.parentChildData.studentUserId, '', this.programSelected).subscribe((data: any) => {
        this.heatMapData = data.items;
        const heatMapCategories = this.heatMapData.map(i => i.categoryClassID);
        if (this.categoryList) {
          this.categoryList.forEach((category: any) => {
            category.isEmpty = !heatMapCategories.includes(category.categoryID);
          });
        }

        this.getCounter();
      },
        () => {
          this.notificationService.show('error', 'Error while fetching student progress category');
        });
    }
  }


  contentProgramChange() {
    const getServicesInputJson = {
      partnerId: this._loginInfoProvider.partnerId,
      studentId: this.parentChildData.studentUserId,
      heatMapTypeId: this.programSelected
    };
    this._commonRequestResponseService.postWithHeader('admin/heatmapcategory/select', getServicesInputJson)
      .subscribe(
        (selectedServicesJSON: any) => {
          this.categoryList = selectedServicesJSON.categoryValues;

        }, () => {
        });
  }

  showBrickDetail(brickObject) {
    this.selectedBrickTitle = brickObject.brick.title;
    if (!brickObject.brick.brickLink && !brickObject.brick.heatMapDetails) {
      const selectedType = {
        studentUserId: this.parentChildData.studentUserId,
        brickId: brickObject.brick.brickId
      };
      this._commonRequestResponseService
        .postWithHeader('student/heatmapMyPlan/get', selectedType)
        .subscribe(
          (brickDetailData: any) => {
            if (
              brickDetailData &&
              brickDetailData.items &&
              brickDetailData.items.length
            ) {
              const hasVideos = !!brickDetailData.items[0].content.filter(
                c => c.type === 'video'
              ).length;
              this.brickDetailData = brickDetailData.items[0].content;
              this.brickDetailTitle = brickDetailData.items[0].title;
              this.draggableModalService.show({
                id: `${this.baseBrickModalId}-${brickObject.brick.brickId}-${
                  brickObject.brick.temperatureClassId
                  }`,
                baseId: this.baseBrickModalId,
                trayTitle: this.brickDetailTitle || this.selectedBrickTitle,
                minHeight: hasVideos ? 400 : null,
                height: hasVideos ? 400 : null,
                initialState: {
                  brickId: brickObject.brick.brickId,
                  brickDetailData: this.brickDetailData,
                  brickAllData: brickDetailData,
                  brickDetailTitle: this.brickDetailTitle,
                  studentUserId: this.parentChildData.studentUserId
                }
              });
            } else {
              this.brickDetailData = [{ type: 'text', content: 'No Content Available' }];
              this.brickDetailTitle = 'No Title';
            }
          },
          () => {
            this.notificationService.show(
              'error',
              'Error while fetching brick data'
            );
          }
        );
    } 
    else if (brickObject.brick.brickLink) {
      if (brickObject.brick.brickLink === 'learningAssessment') {
        const inputJson = {
          productId: '101',
          contextUserId: this.parentChildData.studentUserId
        };

        this._commonRequestResponseService.postWithHeader('shared/HumanEsource', inputJson, ['userId'])
          .subscribe(
            (learningAssessmentJson: any) => {
              this.learningAssessmentJson = learningAssessmentJson;
              const win = window.open(this.learningAssessmentJson['url'], '_blank');
              if (win) {
                win.focus();
              }
            },
            (error) => {
             if (error && error.error && error.error.errorMessage) {
                  this.notificationService.show('error', error.error.errorMessage);
             } else {
            this.notificationService.show('error', 'Error while fetching learning assessment data');
            }
            });
      }
      else if (brickObject.brick.brickLink === 'personalityAssessment') {

        const inputJson = {
          productId: '104',
          contextUserId: this.parentChildData.studentUserId
        };

        this._commonRequestResponseService.postWithHeader('shared/HumanEsource', inputJson, ['userId'])
          .subscribe(
            (personalityAssessmentJson: any) => {
              this.personalityAssessmentJson = personalityAssessmentJson;
              window.open(this.personalityAssessmentJson['url']);
            },
            (error) => {
              if (error && error.error && error.error.errorMessage) {
                this.notificationService.show('error', error.error.errorMessage);
              } else {
                this.notificationService.show('error', 'Error while fetching personality assessment data');
               }
            });
      }
      else if (brickObject.brick.brickLink === 'careerAssessment') {
        const inputJson = {
          studentuserid: this.parentChildData.studentUserId,
        }
      }

      else {
       // do nothing
      }

    } 
    
    else if (brickObject.brick.heatMapDetails) {
      this.brickAllData = brickObject.brick;
      this.brickDetailTitle = brickObject.brick.title;
      this.brickDetailData = [{ type: 'text', content: brickObject.brick.heatMapDetails }];
      this.brickReadStatus = brickObject.brick.done;
      this.draggableModalService.show({
        id: `${this.baseBrickModalId}-${brickObject.brick.brickId}-${
          brickObject.brick.temperatureClassId
          }`,
        baseId: this.baseBrickModalId,
        trayTitle: this.brickDetailTitle,
        initialState: {
          brickId: brickObject.brick.brickId,
          brickDetailData: this.brickDetailData,
          brickDetailTitle: this.brickDetailTitle,
          brickReadStatus: this.brickReadStatus,
          brickAllData: this.brickAllData,
          studentUserId: this.parentChildData.studentUserId
        }
      });
    }
  }

  ngOnDestroy() {
    this.subs.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}
